import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "flex flex-col flex-1 min-h-0 pb-8 w-180" };
const _hoisted_2 = { class: "flex flex-col items-center flex-1 px-12 pt-12" };
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("defs", null, [
    /*#__PURE__*/ _createElementVNode("filter", {
        x: "-4.3%",
        y: "-4.5%",
        width: "108.6%",
        height: "109.7%",
        filterUnits: "objectBoundingBox",
        id: "a"
    }, [
        /*#__PURE__*/ _createElementVNode("feOffset", {
            dy: "2",
            in: "SourceAlpha",
            result: "shadowOffsetOuter1"
        }),
        /*#__PURE__*/ _createElementVNode("feGaussianBlur", {
            stdDeviation: "10",
            in: "shadowOffsetOuter1",
            result: "shadowBlurOuter1"
        }),
        /*#__PURE__*/ _createElementVNode("feColorMatrix", {
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
            in: "shadowBlurOuter1"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("rect", {
        id: "b",
        x: "0",
        y: "0",
        width: "717",
        height: "640",
        rx: "10"
    })
], -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, [
    /*#__PURE__*/ _createElementVNode("text", {
        "font-family": "FiraSans-Regular, Fira Sans",
        "font-size": "16",
        fill: "#121016",
        transform: "translate(-41 58)"
    }),
    /*#__PURE__*/ _createElementVNode("text", {
        "font-family": "FiraSans-Regular, Fira Sans",
        "font-size": "10",
        fill: "#192F61",
        transform: "translate(-41 58)"
    }),
    /*#__PURE__*/ _createElementVNode("g", { transform: "translate(-248 -82)" }, [
        /*#__PURE__*/ _createElementVNode("use", {
            filter: "url(#a)",
            "xlink:href": "#b"
        }),
        /*#__PURE__*/ _createElementVNode("use", { "xlink:href": "#b" })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M7.584 55.91H29.28a5.126 5.126 0 015.126 5.127v3.456a4.915 4.915 0 01-1.017 2.995l-1.39 1.81a1.229 1.229 0 00-.255.748v4.53l1.324.79a.94.94 0 01.007 1.612l-.742.452c-.366.223-.589.62-.589 1.049v4.225l1.331.811a.95.95 0 010 1.623l-.742.452c-.366.223-.589.62-.589 1.049v3.975c0 .403.198.78.53 1.01l.801.555a3.09 3.09 0 011.331 2.54v3.134a4.752 4.752 0 01-4.752 4.752H7.21a4.752 4.752 0 01-4.752-4.752V94.72a3.09 3.09 0 011.33-2.54l.803-.556a1.23 1.23 0 00.529-1.01v-3.975a1.23 1.23 0 00-.59-1.05l-.741-.451a.95.95 0 010-1.623l.742-.452c.366-.223.589-.62.589-1.05v-3.422c0-.403-.198-.78-.53-1.01l-.87-.603a.97.97 0 01.069-1.638l.714-.41a1.23 1.23 0 00.617-1.066v-3.818c0-.27-.09-.534-.254-.748l-1.391-1.81a4.915 4.915 0 01-1.017-2.995v-3.456a5.126 5.126 0 015.126-5.127zm-5.126 96.768v-44.544c0-2.714 2.2-4.915 4.915-4.915H29.49c2.715 0 4.915 2.2 4.915 4.915v44.852",
        stroke: "#DDDBEA",
        "stroke-width": "1.229",
        style: { "mix-blend-mode": "multiply" }
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M25.19 78.029a.614.614 0 110 1.229.614.614 0 010-1.23zm3.072 19.661a.614.614 0 110 1.228.614.614 0 010-1.228zM19.66 73.114a.614.614 0 110 1.228.614.614 0 010-1.228zm-4.914-3.072a.614.614 0 110 1.228.614.614 0 010-1.228zm12.902-2.458a.614.614 0 110 1.229.614.614 0 010-1.229zm-7.988-4.915a.614.614 0 110 1.229.614.614 0 010-1.23z",
        fill: "#DDDBEA",
        style: { "mix-blend-mode": "multiply" }
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#DDDBEA",
        "stroke-width": ".614",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round",
        d: "M3.072 58.368h30.106"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M219.956 0H105.677a1.843 1.843 0 00-1.843 1.843v73.728c0 1.018.825 1.843 1.843 1.843h114.279a1.843 1.843 0 001.843-1.843V1.843A1.843 1.843 0 00219.956 0zm-1.844 3.686v70.042H107.52V3.686h110.592z",
        stroke: "#DDDBEA",
        "stroke-width": "1.229",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round"
    }),
    /*#__PURE__*/ _createElementVNode("g", {
        style: { "mix-blend-mode": "multiply" },
        stroke: "#DDDBEA",
        "stroke-linecap": "round",
        "stroke-width": "1.229"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M129.811 14.624l14.129.246-.343 19.658-14.13-.246z" }),
        /*#__PURE__*/ _createElementVNode("path", { d: "M142.368 34.507a1.229 1.229 0 001.25-1.207l-1.228-.022-.022 1.229zm-9.884-14.614l4.915.086m-4.947 1.758l3.686.064" })
    ]),
    /*#__PURE__*/ _createElementVNode("g", {
        style: { "mix-blend-mode": "multiply" },
        stroke: "#DDDBEA",
        "stroke-linecap": "round",
        "stroke-width": "1.229"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M147.863 16.126l16.954-.296.412 23.59-16.955.296z" }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M151.282 30.397c3.277-.057 7.818-6.046 4.198-7.755-5.448-2.574 1.748 13.204 6.178 3.741",
            style: { "mix-blend-mode": "multiply" }
        }),
        /*#__PURE__*/ _createElementVNode("path", { d: "M163.755 39.445a1.475 1.475 0 001.448-1.5l-1.474.026.026 1.474z" })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M116.121 70.655a.615.615 0 110 1.229.615.615 0 010-1.229zm86.631-1.229a.615.615 0 110 1.23.615.615 0 010-1.23zm-78.643-4.3a.614.614 0 110 1.228.614.614 0 010-1.228zm86.63-1.229a.615.615 0 110 1.229.615.615 0 010-1.23zm3.072-2.457a.614.614 0 110 1.228.615.615 0 010-1.229zm-11.059-6.145a.615.615 0 110 1.229.615.615 0 010-1.229zm11.059-2.457a.614.614 0 110 1.228.614.614 0 010-1.228zM201.523 4.3a.615.615 0 110 1.229.615.615 0 010-1.229zm-91.546 3.686a.615.615 0 110 1.23.615.615 0 010-1.23zm94.004.614a.615.615 0 110 1.23.615.615 0 010-1.23zm-79.872-1.228a.615.615 0 110 1.229.615.615 0 010-1.229zm-3.686 9.83a.615.615 0 110 1.23.615.615 0 010-1.23z",
        style: { "mix-blend-mode": "multiply" },
        fill: "#DDDBEA"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#DDDBEA",
        "stroke-width": "1.229",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round",
        d: "M0 153.293h221.184"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M124.425 69.202h12.59a7.523 7.523 0 017.523 7.523v9.065a4.147 4.147 0 008.294 0v-9.065a7.523 7.523 0 017.523-7.523h12.59a5.016 5.016 0 015.008 4.765l3.646 72.913a5.016 5.016 0 01-5.01 5.266h-55.81a5.016 5.016 0 01-5.009-5.266l3.646-72.913a5.016 5.016 0 015.01-4.765z",
        fill: "#FFAF20"
    }),
    /*#__PURE__*/ _createElementVNode("g", { transform: "translate(136.704 98.078)" }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M5.514 9.101c.99.329 2.089.395 3.172.104a5.504 5.504 0 002.718-1.684",
            stroke: "#00292B",
            "stroke-width": "1.382",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }),
        /*#__PURE__*/ _createElementVNode("circle", {
            fill: "#00292B",
            cx: ".922",
            cy: ".922",
            r: "1"
        }),
        /*#__PURE__*/ _createElementVNode("circle", {
            fill: "#00292B",
            cx: "11.981",
            cy: ".922",
            r: "1"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#FFF",
        "stroke-width": "1.229",
        fill: "#FFF",
        "stroke-linejoin": "round",
        d: "M132.71 115.508h-7.372v9.83h7.373z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M127.795 113.234l.498-1.576a1.23 1.23 0 000-.74l-.381-1.205a1.23 1.23 0 010-.74l.38-1.206c.077-.24.077-.499 0-.74l-.497-1.575h0m2.458 3.89l.497-1.575a1.23 1.23 0 000-.74l-.497-1.575h0",
        stroke: "#DDDBEA",
        "stroke-width": "1.229",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M124.416 117.35a2.765 2.765 0 110 5.53c-1.492 0-2.15-1.088-2.15-2.765 0-1.676.658-2.765 2.15-2.765zm0 1.23c-.65 0-.922.45-.922 1.535 0 1.086.273 1.536.922 1.536a1.536 1.536 0 000-3.072z",
        fill: "#FFF",
        "fill-rule": "nonzero"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M216.292 120.566l-30.559-30.66a7.508 7.508 0 00-11.002.395l-26.194 30.36a7.508 7.508 0 00-.09 9.703l13.273 15.974a15.015 15.015 0 0011.549 5.419h18.54c4.392 0 8.564-1.923 11.417-5.262l13.457-15.752a7.508 7.508 0 00-.39-10.177z",
        stroke: "#FF7645",
        "stroke-width": ".614",
        fill: "#FF7645"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M204.595 117.76l-.497-1.575a1.23 1.23 0 010-.74l.38-1.206a1.23 1.23 0 000-.74l-.38-1.206a1.23 1.23 0 010-.74l.497-1.575h0m-2.457 7.782l-.498-1.575a1.23 1.23 0 010-.74l.498-1.576h0",
        stroke: "#DDDBEA",
        "stroke-width": "1.229",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round"
    }),
    /*#__PURE__*/ _createElementVNode("g", { fill: "#FFF" }, [
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#FFF",
            "stroke-width": "1.229",
            "stroke-linejoin": "round",
            d: "M199.68 120.422h7.373v9.83h-7.373z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M207.974 122.266a2.765 2.765 0 100 5.53c1.492 0 2.15-1.089 2.15-2.766 0-1.676-.658-2.764-2.15-2.764zm0 1.228c.65 0 .922.45.922 1.536s-.272 1.536-.922 1.536a1.536 1.536 0 110-3.072z",
            "fill-rule": "nonzero"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("g", {
        transform: "matrix(-1 0 0 1 186.568 106.7)",
        fill: "#00292B"
    }, [
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: ".936",
            cy: ".939",
            r: "1"
        }),
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "12.162",
            cy: ".939",
            r: "1"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M187.392 100.762a6.758 6.758 0 100 13.516 6.758 6.758 0 000-13.516zm-15.974 0a6.758 6.758 0 100 13.516 6.758 6.758 0 000-13.516zm8.908 7.065h-1.843",
        stroke: "#FFF",
        "stroke-width": "1.229"
    }),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M46.151 89.702a7.426 7.426 0 017.426 7.427v10.943a2.475 2.475 0 104.951 0V97.13a7.426 7.426 0 1114.852 0v11.19a2.475 2.475 0 104.951 0V97.13a7.426 7.426 0 1114.852 0v10.943a2.475 2.475 0 004.951 0V97.13a7.426 7.426 0 017.426-7.427 7.726 7.726 0 017.72 7.42l.944 23.848c.657 16.6-12.266 30.588-28.865 31.245-.396.015-.793.023-1.19.023H67.542c-16.612 0-30.078-13.466-30.078-30.078 0-.397.008-.793.023-1.19l.944-23.847a7.726 7.726 0 017.72-7.42z",
            fill: "#6284D6"
        }),
        /*#__PURE__*/ _createElementVNode("g", {
            stroke: "#00292B",
            "stroke-linecap": "round",
            "stroke-width": "1.475"
        }, [
            /*#__PURE__*/ _createElementVNode("path", { d: "M93.266 122.634a1.475 1.475 0 10-2.95 0h0m-8.846 0a1.475 1.475 0 00-2.95 0h0" }),
            /*#__PURE__*/ _createElementVNode("path", {
                d: "M79.995 127.058a5.898 5.898 0 1011.796 0H79.995z",
                fill: "#00292B",
                "stroke-linejoin": "round"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#FFF",
            "stroke-width": "1.229",
            fill: "#FFF",
            "stroke-linejoin": "round",
            d: "M62.054 125.952h-7.373v9.83h7.373z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M57.14 123.289l.497-1.575a1.23 1.23 0 000-.74l-.38-1.206c-.077-.24-.077-.5 0-.74l.38-1.206a1.23 1.23 0 000-.74l-.497-1.575h0m2.457 7.782l.498-1.575a1.23 1.23 0 000-.74l-.498-1.576h0",
            stroke: "#DDDBEA",
            "stroke-width": "1.229",
            style: { "mix-blend-mode": "multiply" },
            "stroke-linecap": "round"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M53.76 127.795a2.765 2.765 0 110 5.53c-1.492 0-2.15-1.088-2.15-2.765s.658-2.765 2.15-2.765zm0 1.229c-.65 0-.922.45-.922 1.536s.273 1.536.922 1.536a1.536 1.536 0 100-3.072z",
            fill: "#FFF",
            "fill-rule": "nonzero"
        })
    ])
], -1);
const _hoisted_6 = [
    _hoisted_4,
    _hoisted_5
];
const _hoisted_7 = { class: "mt-2 text-2xl font-bold text-center align-middle dark:text-gray-200 text-primary-900" };
const _hoisted_8 = {
    key: 0,
    class: "flex flex-col items-center my-4"
};
const _hoisted_9 = {
    key: 0,
    class: "text-sm-but-a-bit-smaller text-primary-900 dark:text-white"
};
const _hoisted_10 = { class: "flex justify-between" };
const _hoisted_11 = { class: "flex ml-28" };
const _hoisted_12 = { class: "flex self-end gap-6 mr-10" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.workspaces.invites_modal'),
    compatConfig: {
        COMPONENT_V_MODEL: false
    }
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { searchTermToUser } from '@/helpers/users';
import { useSeatsValidations } from '@/composables/seatsValidations';
import transitions from '@/helpers/transitions';
import Dialog from '@/components/Dialog.vue';
import Modal from '@/components/Modal.vue';
import UserInput from '@/components/workspaces/UserInput.vue';
import SeatsModifier from '@/components/workspaces/SeatsModifier.vue';
import { FEATURE_FLAGS } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'InvitesAndSeatsModal',
    props: {
        allowDiscardSearchOnCancel: { type: Boolean },
        isLoading: { type: Boolean },
        modelValue: null,
        pendingInvites: null,
        searchTerm: null,
        seatsToBuy: null,
        sendLater: { type: Boolean },
        show: { type: Boolean },
        users: null,
        variant: null,
        workspace: null
    },
    emits: [
        'cancel',
        'send',
        'update:modelValue',
        'update:seatsToBuy',
        'update:searchTerm'
    ],
    setup(__props, { emit }) {
        const props = __props;
        watch(() => props.show, () => (step.value = 'invitations'));
        const isWorkspacePro = computed(() => (props.workspace ? props.workspace.plan === 'pro' : false));
        const store = useStore();
        const isWorkspaceOwner = computed(() => store.getters.isWorkspaceOwner);
        const disallowExternalToWorkspace = computed(() => !isWorkspaceOwner.value && requiredSeatsToBuy.value > 0 && isPricingEnabled);
        const sendButtonVariant = computed(() => (props.sendLater ? 'later' : 'immediate'));
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const { hasToBuySeats, displayableSeatsTaken, displayableSeatsAvailable, requiredSeatsToBuy } = useSeatsValidations({
            selectedUsers: computed(() => [...props.modelValue, ...(props.pendingInvites || [])]),
            searchTerm: computed(() => props.searchTerm),
            seatsToBuy: computed(() => props.seatsToBuy),
            workspace: computed(() => props.workspace)
        });
        const step = ref('invitations');
        const isBuySeatsButtonDisabled = ref(false);
        function consumeRemainingSearchTerm() {
            if (props.searchTerm.trim().length > 0) {
                const user = searchTermToUser(props.searchTerm, props.users);
                if (user) {
                    handleModelValueUpdate([...props.modelValue, user]);
                }
                else {
                    return false;
                }
            }
            return true;
        }
        function clearSearchTerm() {
            emit('update:searchTerm', '');
        }
        function handleNext() {
            if (props.workspace.plan === 'pro' && hasToBuySeats.value) {
                step.value = 'seats';
                emit('update:seatsToBuy', requiredSeatsToBuy.value);
            }
            else if (!consumeRemainingSearchTerm()) {
                return;
            }
            else {
                clearSearchTerm();
                emit('send');
            }
        }
        function handleSend() {
            if (!consumeRemainingSearchTerm()) {
                return;
            }
            clearSearchTerm();
            emit('send');
        }
        function handleCancel() {
            if (!props.allowDiscardSearchOnCancel && !consumeRemainingSearchTerm()) {
                return;
            }
            clearSearchTerm();
            emit('cancel');
            isBuySeatsButtonDisabled.value = false;
        }
        function handleBack() {
            step.value = 'invitations';
            isBuySeatsButtonDisabled.value = false;
        }
        function handleModelValueUpdate(value) {
            emit('update:modelValue', value);
        }
        function handleSearchTermUpdate(value) {
            emit('update:searchTerm', value);
        }
        function handleSeatsToBuyUpdate(value) {
            if (value < requiredSeatsToBuy.value) {
                isBuySeatsButtonDisabled.value = true;
            }
            else {
                isBuySeatsButtonDisabled.value = false;
            }
            emit('update:seatsToBuy', value);
        }
        const { scale } = transitions;
        const { scaleIn, scaleOut } = scale;
        return (_ctx, _cache) => {
            const _component_TextButton = _resolveComponent("TextButton");
            const _component_PillButton = _resolveComponent("PillButton");
            const _component_TransitionA11y = _resolveComponent("TransitionA11y");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createBlock(Modal, { class: "z-50 overflow-auto w-180" }, {
                default: _withCtx(() => [
                    _createVNode(_component_TransitionA11y, {
                        css: false,
                        enter: _unref(scaleIn),
                        leave: _unref(scaleOut),
                        class: "px-2 my-2"
                    }, {
                        default: _withCtx(() => [
                            (__props.show)
                                ? (_openBlock(), _createBlock(Dialog, { key: 0 }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_1, [
                                            _createElementVNode("div", _hoisted_2, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    viewBox: "0 0 222 154",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                                    "svg-inline": '',
                                                    src: '@/assets/images/watercooler.svg',
                                                    class: _normalizeClass('max-w-52 max-h-52')
                                                }, _hoisted_6, 8, _hoisted_3)),
                                                _createElementVNode("h1", _hoisted_7, _toDisplayString(step.value === 'invitations'
                                                    ? _ctx.$t(`invitations_step_body_${__props.variant}`)
                                                    : _ctx.$t('seats_step_body')), 1),
                                                (step.value === 'invitations')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                        (_unref(isWorkspacePro) && _unref(isPricingEnabled))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('seats_available', {
                                                                taken: _unref(displayableSeatsTaken),
                                                                available: _unref(displayableSeatsAvailable)
                                                            })), 1))
                                                            : _createCommentVNode("", true),
                                                        _createVNode(UserInput, {
                                                            "model-value": __props.modelValue,
                                                            users: __props.users,
                                                            "disallow-external-to-workspace": _unref(disallowExternalToWorkspace),
                                                            "disallow-external-to-workspace-placeholder": !_unref(isWorkspaceOwner) && _unref(displayableSeatsAvailable) === 0,
                                                            "search-term": __props.searchTerm,
                                                            class: "min-h-36 w-150",
                                                            size: "lg",
                                                            "onUpdate:modelValue": handleModelValueUpdate,
                                                            "onUpdate:searchTerm": handleSearchTermUpdate
                                                        }, null, 8, ["model-value", "users", "disallow-external-to-workspace", "disallow-external-to-workspace-placeholder", "search-term"])
                                                    ]))
                                                    : (_openBlock(), _createBlock(SeatsModifier, {
                                                        key: 1,
                                                        workspace: __props.workspace,
                                                        "model-value": __props.seatsToBuy,
                                                        class: "mt-10 mb-24",
                                                        "onUpdate:modelValue": handleSeatsToBuyUpdate
                                                    }, null, 8, ["workspace", "model-value"]))
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("div", _hoisted_11, [
                                                    (step.value === 'seats')
                                                        ? (_openBlock(), _createBlock(_component_TextButton, {
                                                            key: 0,
                                                            onClick: handleCancel
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                                            ], undefined, true),
                                                            _: 1
                                                        }))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_12, [
                                                    (step.value === 'invitations')
                                                        ? (_openBlock(), _createBlock(_component_TextButton, {
                                                            key: 0,
                                                            onClick: handleCancel
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                                            ], undefined, true),
                                                            _: 1
                                                        }))
                                                        : (_openBlock(), _createBlock(_component_PillButton, {
                                                            key: 1,
                                                            kind: "secondary",
                                                            onClick: handleBack
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                                                            ], undefined, true),
                                                            _: 1
                                                        })),
                                                    (step.value === 'invitations')
                                                        ? (_openBlock(), _createBlock(_component_PillButton, {
                                                            key: 2,
                                                            disabled: _unref(disallowExternalToWorkspace),
                                                            onClick: handleNext
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                                                    _createTextVNode(_toDisplayString(_unref(hasToBuySeats) && __props.workspace?.plan === 'pro'
                                                                        ? _ctx.$t('next')
                                                                        : _ctx.$t(`send_${_unref(sendButtonVariant)}`)), 1)
                                                                ])), [
                                                                    [_directive_tooltip, _unref(disallowExternalToWorkspace) && _ctx.$t('errors.unavailable_seats')]
                                                                ])
                                                            ], undefined, true),
                                                            _: 1
                                                        }, 8, ["disabled"]))
                                                        : _withDirectives((_openBlock(), _createBlock(_component_PillButton, {
                                                            key: 3,
                                                            disabled: isBuySeatsButtonDisabled.value,
                                                            loading: __props.isLoading,
                                                            onClick: handleSend
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('buy')), 1)
                                                            ], undefined, true),
                                                            _: 1
                                                        }, 8, ["disabled", "loading"])), [
                                                            [_directive_tooltip,
                                                                isBuySeatsButtonDisabled.value
                                                                    ? _unref(requiredSeatsToBuy) > 1
                                                                        ? _ctx.$t('invalid_seats_amount', { seats: _unref(requiredSeatsToBuy) })
                                                                        : _ctx.$t('invalid_one_seat_amount')
                                                                    : null
                                                            ]
                                                        ])
                                                ])
                                            ])
                                        ])
                                    ], undefined, true),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                    }, 8, ["enter", "leave"])
                ], undefined, true),
                _: 1
            }));
        };
    }
});
